'use strict';

module.exports = /*@ngInject*/ ["$scope", "$rootScope", "$stateParams", "MonitoringStoreService", "ProjectService","ConfigurationStoreService", function SummaryMonitoringPageController(
    $scope,
    $rootScope,
    $stateParams,
    MonitoringStoreService,
    ProjectService,
    ConfigurationStoreService) {

    var vm = this;

    vm.projectId = $stateParams.projectId;
    vm.trainId = $stateParams.trainId;

    vm.train;
    vm.trainTableData;

    var name = "summary";


    /*
     FUNCTIONS
     */


    var deRegisterTrainsUpdatedListener = $rootScope.$on('trains-updated', function(){  // TODO to be removed once we can get all info of the train information table from calling a single train endpoint
       getTrainData();
    });

    $rootScope.$on('current-train-updated', function(){
        getTrainData();
    });    

    function getTrainData() {
        vm.train = MonitoringStoreService.getTrainByTrainId(vm.projectId, vm.trainId);
        if(vm.train) {

            var trainType = vm.train.diagnostics ? vm.train.diagnostics.config : vm.train.trainType;
            if (trainType) { 
                var trainTypeConfiguration = ConfigurationStoreService.getTrainTypeConfiguration(vm.train.projectId, trainType);
                vm.train.trainTypeConfiguration = trainTypeConfiguration;
            }
            vm.trainTableData = [ vm.train ];
        }        
    }

    function init() {
        $scope.$emit('init-child', name);
        getTrainData();
    }

    init();

    $scope.$on('$destroy', function () {
        vm.train = undefined;
        vm.trainTableData = undefined;
        deRegisterTrainsUpdatedListener();
    });

}];
